import './css/bootstrap.min.css';
import './App.css';
import Login from "./Login";
import Navbar from "./Navbar";
import Controller from "./Controller";
import Forgotpassword from "./Forgotpassword";
import axios from 'axios';
import useLocalStorageState from 'use-local-storage-state';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
function App() {
  const [token, setToken] = useLocalStorageState('token', '');
  const [logid, setLogid] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadinpage, setLoadinpage] = useState(<div style={{paddingTop:'200px'}}> <center><Spinner animation="grow" variant="primary" />
  <Spinner animation="grow" variant="secondary" />
  <Spinner animation="grow" variant="success" />
  <Spinner animation="grow" variant="danger" />
  <Spinner animation="grow" variant="warning" />
  <Spinner animation="grow" variant="info" />
  <Spinner animation="grow" variant="light" />
  <Spinner animation="grow" variant="dark" /></center> </div>);
  useEffect(() => {
    if (token) {
      let endpoint = process.env.REACT_APP_PHP_URL + 'me';
      const BEARER_TOKEN = token;

      axios(endpoint, {
        method: "GET",
        withCredentials: true,
        headers: {
          'Authorization': `Bearer ${BEARER_TOKEN}`,
          'Content-Type': 'application/json',
        }
      })
      .then(response => {
        if (response.data?.data?.id > 0) {
          setLogid(response.data.data.id);
        } else {
          localStorage.clear();
        }
      })
      .catch(error => {
        localStorage.clear();
      })
      .finally(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [token]);

  if (loading) return <div>{loadinpage}</div>;

  if (logid !== 0) {
    return (
      <>
        <Navbar />
        <Controller />
      </>
    );
  } else {
    return (
      <BrowserRouter>
        <Routes>
          <Route index element={<Login />} />
          <Route path="/forgotpassword/:id" element={<Forgotpassword />} />
          <Route path="/reset-password/:id" element={<Forgotpassword />} />
          <Route path="/forgotpassword" element={<Forgotpassword />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
